<div>
    <div class="map-div"><span class="title">Property on map</span><span><img (click)="close()" title="Close" class="close-con" src="../../../../assets/icon/w-close.svg" alt=""></span></div>
    <div #gmap class="map"></div>
</div>